import { ApiStation } from "./ApiCountry";
import { City } from "./RoutePickerModel";

export const isPossibleDestination = (originCity: City, destinationCity: City | ApiStation): boolean =>
	destinationCity.markets.includes(originCity.code);
